export const isImmutable = (o: any): boolean => typeof o?.toJS === 'function';

export const toJsIfImmutable = <R = any>(o: any): R =>
  isImmutable(o) ? o.toJS() : o;

const toPathArray = (
  path: string | number | (string | number)[],
): (string | number)[] => {
  if (Array.isArray(path)) {
    return path;
  }
  if (typeof path === 'string') {
    return path.split('.');
  }
  return [path];
};

export const get = <R = any>(
  o: any,
  path: string | number | (string | number)[],
  defaultValue?: R,
): R => {
  const pathArr = toPathArray(path);
  if (isImmutable(o)) {
    return o.getIn(pathArr, defaultValue);
  }
  let result = o;
  for (const key of pathArr) {
    result = result?.[key];
    if (result === undefined) {
      return defaultValue as R;
    }
  }
  return result;
};
